module.exports = __webpack_public_path__ + "img/thumb_20.5bc84669.png";